import { db } from "./firebaseConfig";
import { doc, updateDoc } from "firebase/firestore";

const ActualizarPrecioDB = ({
  id,
  precio,
  userMod,
  fechaMod,
}) => {
  return updateDoc(doc(db, "itemsst", id), {
    price: precio,
    usermod: userMod,
    fechamod: fechaMod,
  });
};

export default ActualizarPrecioDB;